"use client";
import React, {
  useState,
  useRef,
  useEffect,
  FunctionComponent,
  useContext,
  Fragment,
} from "react";
import dayjs from "dayjs";
import classnames from "classnames";
import DateComponent from "./dateComponent";
import "./styles.scss";
import RightArrow from "icons/rightChevron.svg";
import LeftArrow from "icons/leftChevron.svg";
import { Container } from "src/components/ct-design";
import { getSearchParams, jsonToQueryString } from "src/utils/generalUtils";
import { usePathname, useRouter } from "next/navigation";
import { updateRecentSearch } from "src/utils/browserHelpers";
import { ResultsContext } from "src/context/resultsContext/context";

export const dynamic = "force-dynamic";
interface Props {
  isSEOPage?: boolean;
  fromCityId?: string;
  toCityId?: string;
}
const DateTabs: FunctionComponent<Props> = (props) => {
  const { fromCityId, toCityId, isSEOPage = false } = props;
  const { fromCity, toCity, fromCityName, toCityName } = getSearchParams();

  const [datesArray, setDatesArray] = useState<string[] | []>([]);
  const [visibleDates, setVisibleDates] = useState<string[]>([]);
  const navRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const [currentSlide, setCurrentSlide] = useState(0);
  const itemsToShow = 6;
  const { clearContextData, resultsData, resultsLoading } =
    useContext(ResultsContext);
  const departDate = resultsData?.sc?.journeyDate;
  const pathName = usePathname();

  // const { departDate, setLoading, fromCityName, toCityName } = props;
  useEffect(() => {
    if (departDate) {
      const dates: string[] = [];
      for (let i = 0; i < 90; i++) {
        const date = dayjs().add(i, "days").format("YYYY-MM-DD");
        dates.push(date);
      }
      setDatesArray(dates);

      let visibleItems = dates.slice(currentSlide, currentSlide + itemsToShow);
      if (visibleItems.length < itemsToShow) {
        visibleItems = dates.slice(dates.length - itemsToShow, dates.length);
      }

      if (!visibleItems.includes(departDate)) {
        for (let i = currentSlide + itemsToShow; i <= dates.length; ) {
          let newVisibleItems = dates.slice(i, i + itemsToShow);
          if (newVisibleItems.length < itemsToShow) {
            newVisibleItems = dates.slice(
              dates.length - itemsToShow,
              dates.length
            );
          }
          if (newVisibleItems.includes(departDate)) {
            setCurrentSlide(i);
            setVisibleDates(newVisibleItems);
            break;
          } else {
            i = i + itemsToShow;
          }
        }
      } else setVisibleDates(visibleItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departDate]);

  const handleVisibleDates = (slideNumber: number) => {
    let newVisibleItems = datesArray.slice(
      slideNumber,
      slideNumber + itemsToShow
    );
    if (newVisibleItems.length < itemsToShow) {
      newVisibleItems = datesArray.slice(
        datesArray.length - itemsToShow,
        datesArray.length
      );
    }
    setVisibleDates(newVisibleItems);
  };

  const handleSelectDate = (date: string) => {
    if (date === departDate) return;

    const updateParams = getSearchParams();
    updateParams.journeyDate = date;

    const getQuery = jsonToQueryString(updateParams);

    if (isSEOPage) {
      window.open(
        `/bus/results?fromCity=${fromCityId}&toCity=${toCityId}&journeyDate=${date}`,
        "_blank"
      );
      return;
    }
    router.refresh();

    router.push(`${pathName}?${getQuery}`);
    clearContextData();

    // if (oldJourneyDate !== date) setLoading(true);
    updateRecentSearch({
      arrival: {
        cityId: parseInt(toCity),
        cityName: toCityName,
      },
      departure: {
        cityId: parseInt(fromCity),
        cityName: fromCityName,
      },
      journeyDate: date,
    });
  };

  useEffect(() => {
    if (resultsLoading) {
      setCurrentSlide(0);
    }
  }, [resultsLoading]);

  const dateBarClassName = classnames(
    "dateTabsWrapper bg-neutral-100 p-sticky flex flex-middle"
  );

  const handleNext = () => {
    const nextSlide = currentSlide + itemsToShow;
    if (nextSlide >= datesArray.length) return;

    setCurrentSlide(nextSlide >= datesArray.length ? 0 : nextSlide);
    handleVisibleDates(nextSlide >= datesArray.length ? 0 : nextSlide);
  };

  const handlePrevious = () => {
    const previousSlide = currentSlide - itemsToShow;
    if (previousSlide < 0) return;

    setCurrentSlide(
      previousSlide < 0 ? datesArray.length - itemsToShow : previousSlide
    );
    handleVisibleDates(
      previousSlide < 0 ? datesArray.length - itemsToShow : previousSlide
    );
  };

  return departDate ? (
    <Container className={dateBarClassName} css={{ padding: "2px 0px" }}>
      <div className="c-pointer disable-selection h-6" onClick={handlePrevious}>
        <LeftArrow fill="#1A1A1A" />
      </div>

      <Container
        className="dateTabs flex flex-nowrap w-100p"
        ref={navRef}
        data-testid="date-tabs"
        css={{ justifyContent: "space-evenly" }}
      >
        {visibleDates.map((date, index) => {
          return (
            <Fragment key={index}>
              <DateComponent
                departDate={departDate}
                date={date}
                index={`${date}_${index}`}
                handleClick={(date: string) => handleSelectDate(date)}
                key={`${date}_${index}`}
                lastElement={index === visibleDates.length - 1}
              />
              {index !== visibleDates.length - 1 ? (
                <div className="py-2">
                  <Container
                    className="h-100p"
                    css={{ borderLeft: "1px solid #e6e6e6" }}
                  />
                </div>
              ) : null}
            </Fragment>
          );
        })}
      </Container>
      <div
        className="ml-1 c-pointer disable-selection h-6"
        onClick={handleNext}
      >
        <RightArrow fill="#1A1A1A" />
      </div>
    </Container>
  ) : null;
};

export default DateTabs;
